import { gql } from "@apollo/client";
import { useCallback } from "react";
import { useQuery } from "@apollo/client/react";
import { ALLERGENS_FRAGMENT, WEIGHT_FRAGMENT, FOOD_ENERGY_FRAGMENT } from "../../fragments/menuItem";

import type { MenuItems } from "../../types/menuItemTypes";
import type { UseOptions } from "../hookTypes"

const GET_MENU_ITEMS = gql`
  query menuItems($menuId: ID!) {
    menuItems(menuId: $menuId) {
      id
      menuItemLangs {
        id
        name
        description
        language
      }
      ...AllergensFragment
      ...WeightFragment
      ...FoodEnergyFragment
      vegan
      chili
      hot
      price
      img {
        small
        medium
      }
      menuId
      mainItemLang {
        id
        name
        description
        language
      }
      menuSectionIds
      menuSections {
        id
        name
      }
      updatedAt
    }
  }
  ${ALLERGENS_FRAGMENT}
  ${WEIGHT_FRAGMENT}
  ${FOOD_ENERGY_FRAGMENT}
`;

const useMenuItems = (id: string | number | undefined, options?: UseOptions) => {
  const { fetchPolicy = "cache-and-network", refetchOnMount = false } = options ?? {};

  const { data, loading, error, refetch } = useQuery<MenuItems>(GET_MENU_ITEMS, {
    variables: { menuId: String(id) },
    fetchPolicy,
    notifyOnNetworkStatusChange: true,
  });

  if (refetchOnMount && !loading) {
    refetch();
  }

  const menuItems = data?.menuItems;

  const refetchMenuItems = useCallback(async () => {
    try {
      await refetch();
    } catch {
      // log if need
    }
  }, [refetch]);

  return {
    menuItems,
    loading,
    error: error as Error | null | undefined,
    refetchMenuItems,
  };
}

export default useMenuItems
